module.exports = __webpack_public_path__ + "static/pink-bg-9ddf655a52789375b53923a20ae87dd5.png";